export class LocalStorageBase {
  constructor(namespace = 'default') {
    this.namespace = namespace;
  }

  getItem = (key) => localStorage.getItem(this.formatKey(key));

  setItem = (key, value) => {
    localStorage.setItem(this.formatKey(key), value);
  };

  removeItem = (key) => localStorage.removeItem(this.formatKey(key));

  formatKey = (key) => `${this.namespace}/${key}`;
}
